import { render } from "./BuybackTable.vue?vue&type=template&id=479d1408&scoped=true&ts=true&lang=pug"
import script from "./BuybackTable.vue?vue&type=script&lang=ts"
export * from "./BuybackTable.vue?vue&type=script&lang=ts"

import "./BuybackTable.vue?vue&type=style&index=0&id=479d1408&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479d1408"]])

export default __exports__